module.exports = "779502b6c19435daa57710ab2870a3e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-r-2.png
// module id = 59
// module chunks = 0